export default __webpack_public_path__ + "static/media/pin.1bf90b25.svg";